export default __webpack_public_path__ + "static/media/mobile-development-selected.c2bb6b72.svg";